import { Icon, varBounce } from '@aibees/shared/components';
import { CompactLayout } from '@aibees/shared/layouts';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { m } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as Styled from './styles';

export default function View404() {
  const theme = useTheme();

  return (
    <CompactLayout>
      <Box
        sx={{
          backgroundColor: theme.palette.common.white,
          borderRadius: theme.spacing(2),
          p: theme.spacing(0, 4, 6, 4),
          height: 470,
          width: 560,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: '12px',
        }}
      >
        <div
          style={{
            backgroundImage: 'url(assets/images/error-page-background.svg)',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <m.div variants={varBounce().in}>
            <Styled.Img src="assets/images/404.svg" alt="logo" />
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography
              variant="h6"
              fontWeight={700}
              color="common.black"
              pb={theme.spacing(4)}
            >
              Sorry, Page Not Found
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography
              variant="body4"
              fontWeight={500}
              color="grey.500"
              pb={theme.spacing(4)}
            >
              Sorry, we couldn’t find the page you’re looking for. <br />
              Perhaps you’ve mistyped the Url? <br />
              Be sure to check your spelling.
            </Typography>
          </m.div>
        </div>
        <div>
          <m.div variants={varBounce().in}>
            <Link to="/">
              <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<Icon name="arrow-left-fill" />}
              >
                Back to AI Ark
              </Button>
            </Link>
          </m.div>
        </div>
      </Box>
    </CompactLayout>
  );
}
